<template>
  <section id="my-layout">
    <LayoutContainer :tabs="tabs">
      <template v-slot:header-content-left>
        <div class="d-md-flex align-items-center">
          <div class="mr-3 mb-2 d-flex">
            <div class="border-gradient d-flex justify-content-center align-items-center rounded-circle">
              <ShrAvatar
               class=""
                size="120px"
                :text="
                  $helpers.createInitials(
                    user.first_name,
                    user.last_name
                  )
                "
                :key="user.avatar"
                :src="user.avatar || ''"
              />
            </div>
          </div>
          <div>
            <h2 class="fs-24 text-white">{{ user.first_name }} {{ user.last_name }}</h2>
            <p v-if="cv.job_title" class="fs-16 text-light-dark fw-500 mb-0">
              {{ cv.job_title }}
            </p>
            <p class="text-light-dark fs-14 mb-0">{{ user.email }}</p>
            <p v-if="cv.state" class="text-light-dark mb-1">
              {{ cv.state ? cv.state : '' }}
              {{ cv.country ? ', '+ cv.country : '' }}
            </p>
          </div>
        </div>
      </template>
      <template v-slot:header-content-right>
         {{ user.last_login ? 'Last logged in '+$moment(user.last_login).fromNow() : '' }}
      </template>
      <template v-slot:header-content-right-btn>
          <button @click.prevent="goToEditProfilePage" class="btn btn-primary fw-500 flex-fill flex-md-grow-0 px-md-5">
            Edit profile
          </button>
      </template>
      <template v-slot:body-content-right> 
        <div>
            <JobAssessmentCard class="mb-3"/>
            <JobOfferCard :offers="jobOffers" class="mb-3"/>
            <JobInterviewCard class="mb-3"/>
            <JobRecommendationCard/>
        </div>
      </template>
    </LayoutContainer>
  </section>
</template>

<script>
import LayoutContainer from "../../components/LayoutContainer/LayoutContainer.vue"; 
import JobAssessmentCard from "./includes/JobAssessmentCard.vue";
import JobOfferCard from "./includes/JobOfferCard.vue";
import JobModel from "../../models/JobModel";
import CandidateModel from "../../models/CandidateModel";
import UploadCVCard from "./includes/UploadCVCard.vue";
import JobInterviewCard from "./includes/JobInterviewCard.vue";
import JobRecommendationCard from "./includes/JobRecommendationCard.vue"

export default {
  name: "MyLayout",
  mixins: [
    JobModel,
    CandidateModel
  ],
  components: {
    LayoutContainer,
    JobAssessmentCard,
    JobOfferCard,
    UploadCVCard,
    JobInterviewCard,
    JobRecommendationCard
  },
  mounted() {
    this.getCandidateJobs()
    this.user = {...this.$store.state.user}
    const cvs = this.$helpers.getObjectProperty(this.user, 'cvs', [])
    this.cv = cvs.length ? cvs[cvs.length - 1] : {};
  },
  data() {
    return {
      user: {},
      cv: {},
      jobOffers: [],
      userProfile: {}
    }
  },
  computed: {
    getAvatar(){
      return '/img/avatar-cv.jpg'
    },
    userLocation() {
      const location = this.$helpers.getObjectProperty(this.userProfile, 'location_details.name', '')
      const country = this.$helpers.getObjectProperty(this.userProfile, 'location_details.country.name', '')
      return {
        location,
        country
      }
    },
    tabs() {
      return [
        { 
          title: 'Overview', 
          routeName: 'MyOverview' 
        },
        { 
          title: 'My application', 
          routeName: 'MyApplication' 
        }
      ]
    },
    routeIsMyOverview() {
      return this.$route.name === 'MyOverview'
    }
}, 
  methods:{
      goToEditProfilePage() {
        // this.trackEvent('Navigated to edit profile page', {});
        this.$router.push({name: 'ProfileSettings'})
      },

      getCandidateJobs() {
        this.loading = true
        this.CandidateModel.getCandidateJobs()
        .then((resp) => {
          this.jobOffers = resp.data.data.filter(item => {
            return item.applicant_offer_status === 'pending' && this.$moment().isSameOrBefore(item.offer_letter_expires_at);
          });

        })
        .finally(() => {
          this.loading = false
        })
      }
  }
}
</script>

<style lang="scss" scoped>
  .profile-image{
    border: 1px solid #133252;
  }
  ::v-deep .profile-image .image-alt{
    font-weight: 400!important;
    font-size: 60px!important;
  }
  .border-gradient{
    padding: 1px;
    background: linear-gradient(to left, #29B32F, #296DB3);
  }

@media only screen and (max-width: 767px) {
  .profile-image, ::v-deep .profile-image .image-alt{
    width: 48px!important;
    height: 48px!important;
    font-size: 25px!important;
  }
  .fs-24{
    font-size: 20px;
  }
  .fs-16{
    font-size: 14px;
  }
}
</style>
